export const departments = [
    {
        name: "Human Resources",
        value: "hr"
    },

    {
        name: "Information Technology",
        value: "it"
    },

    {
        name: "Sales",
        value: "sales"
    },

    {
        name: "Marketing",
        value: "marketing"
    },
]

export const newDepartments = [
    { name: "Cased Hole", value: "Cased Hole" },
    { name: "Cementing Bulk Plant", value: "Cementing Bulk Plant" },
    { name: "Cementing Design Centre", value: "Cementing Design Centre" },
    { name: "Cementing Operations", value: "Cementing Operations" },
    { name: "Coiled Tubing", value: "Coiled Tubing" },
    { name: "Process & Pipeline", value: "Process & Pipeline" },
    { name: "Completions", value: "Completions" },
    { name: "Drilling", value: "Drilling" },
    { name: "Drilling and Completion Fluids", value: "Drilling and Completion Fluids" },
    { name: "Finance & Administration", value: "Finance & Administration" },
    { name: "Formation Evaluation", value: "Formation Evaluation" },
    { name: "Human Resources", value: "Human Resources" },
    { name: "Information Technology", value: "Information Technology" },
    { name: "Integrated Services Management", value: "Integrated Services Management" },
    { name: "Log Quality Control & Data Processing", value: "Log Quality Control & Data Processing" },
    { name: "Maintenance", value: "Maintenance" },
    { name: "Tenders and Contracts", value: "Tenders and Contracts" },
    { name: "Purchasing", value: "Purchasing" },
    { name: "QHSSE", value: "QHSSE" },
    { name: "Slickline", value: "Slickline" },
    { name: "Strategic Business and Compliance Services", value: "Strategic Business and Compliance Services" },
    { name: "Surface Logging Services", value: "Surface Logging Services" },
    { name: "Treating Chemicals", value: "Treating Chemicals" },
    { name: "Tubing Conveyed Perforating", value: "Tubing Conveyed Perforating" },
    { name: "Warehouse & Inventory", value: "Warehouse & Inventory" },
    { name: "Wireline", value: "Wireline" },
    { name: "HSSE", value: "HSSE" },
    { name: "Coiled Tubing/Process & Pipeline Services", value: "Coiled Tubing/Process & Pipeline Services" },
];


export const locations = [
    { name: "1-5 Princess Margaret Street, San Fernando", value: "1-5 Princess Margaret Street, San Fernando" },
    { name: "1st Avenue South, Chaguaramas", value: "1st Avenue South, Chaguaramas" },
    { name: "Lot# 3B Otaheite Industrial Estate, Otaheite", value: "Lot# 3B Otaheite Industrial Estate, Otaheite" },
    { name: "#10 Tarran Industrial Estate, South Trunk Road, La Romaine", value: "#10 Tarran Industrial Estate, South Trunk Road, La Romaine" },
    { name: "Genco Drive, Galeota", value: "Genco Drive, Galeota" },
    { name: "Krondstadt Island Service Center, Kronstadt Island", value: "Krondstadt Island Service Center, Kronstadt Island" },
    { name: "59 Sackville Street, Port of Spain", value: "59 Sackville Street, Port of Spain" },
    { name: "La Retriate Road, Gonzales Village, Guapo (TTC)", value: "La Retriate Road, Gonzales Village, Guapo (TTC)" },
    { name: "La Retriate Road, Gonzales Village, Guapo (CMT-CT)", value: "La Retriate Road, Gonzales Village, Guapo (CMT-CT)" },
    { name: "18 Lady Hailes Avenue, San Fernando", value: "18 Lady Hailes Avenue, San Fernando" },
    { name: "Lot #2 Christo Trace, Belle Vue Estate, South Oropouche", value: "Lot #2 Christo Trace, Belle Vue Estate, South Oropouche" },
    { name: "Land Of Canaan, Guyana", value: "Land Of Canaan, Guyana" }
    
];

export const externalCustomers = [
    {
        name: "A & V Oil and Gas Ltd.",
        value: "A & V Oil and Gas Ltd."
    },
    {
        name: "Atlantic LNG",
        value: "Atlantic LNG"
    },
    {
        name: "BHP Billiton",
        value: "BHP Billiton"
    },
    {
        name: "BG International Limited",
        value: "BG International Limited"
    },
    {
        name: "BP Trinidad & Tobago LLC",
        value: "BP Trinidad & Tobago LLC"
    },
    {
        name: "CGX Energy",
        value: "CGX Energy"
    },
    {
        name: "Caribbean Industrial & Agricultural Chemical Services (CIACS)",
        value: "Caribbean Industrial & Agricultural Chemical Services (CIACS)"
    },
    {
        name: "Caribbean Nitrogen Company",
        value: "Caribbean Nitrogen Company"
    },
    {
        name: "Caribbean Well Services",
        value: "Caribbean Well Services"
    },
    {
        name: "Challenger Energy",
        value: "Challenger Energy"
    },
    {
        name: "Columbus Energy Services Limited",
        value: "Columbus Energy Services Limited"
    },
    {
        name: "Corpro Reservoir Group",
        value: "Corpro Reservoir Group"
    },
    {
        name: "Denovo Energy Trinidad Limited",
        value: "Denovo Energy Trinidad Limited"
    },
    {
        name: "EOG Resource Trinidad Ltd",
        value: "EOG Resource Trinidad Ltd"
    },
    {
        name: "Esso Exploration and Production Guyana Limited",
        value: "Esso Exploration and Production Guyana Limited"
    },
    {
        name: "Four Phase Limited",
        value: "Four Phase Limited"
    },
    {
        name: "Halliburton Trinidad Ltd.",
        value: "Halliburton Trinidad Ltd."
    },
    {
        name: "Heritage Petroleum Company Limited",
        value: "Heritage Petroleum Company Limited"
    },
    {
        name: "IAL Engineering Services Ltd",
        value: "IAL Engineering Services Ltd"
    },
    {
        name: "Industrial Plant Services Ltd. (IPSL)",
        value: "Industrial Plant Services Ltd. (IPSL)"
    },
    {
        name: "Lease Operators Ltd.",
        value: "Lease Operators Ltd."
    },
    {
        name: "Lennox Petroleum Services Ltd.",
        value: "Lennox Petroleum Services Ltd."
    },
    {
        name: "Massy Wood Group Ltd",
        value: "Massy Wood Group Ltd"
    },
    {
        name: "Methanex Trinidad Limited",
        value: "Methanex Trinidad Limited"
    },
    {
        name: "Mitsubishi Heavy Industries",
        value: "Mitsubishi Heavy Industries"
    },
    {
        name: "Moonsie Oil Company Limited",
        value: "Moonsie Oil Company Limited"
    },
    {
        name: "PCS Nitrogen Trinidad",
        value: "PCS Nitrogen Trinidad"
    },
    {
        name: "Perenco T&T Ltd.",
        value: "Perenco T&T Ltd."
    },
    {
        name: "Petroleum Contractors Services Limited (PCSL)",
        value: "Petroleum Contractors Services Limited (PCSL)"
    },
    {
        name: "Primera Oil & Gas Company Ltd",
        value: "Primera Oil & Gas Company Ltd"
    },
    {
        name: "Proman AG Trinidad Limited",
        value: "Proman AG Trinidad Limited"
    },
    {
        name: "Range Resources Trinidad Limited",
        value: "Range Resources Trinidad Limited"
    },
    {
        name: "Phenonix Park Gas Processors Limited (PPGPL)",
        value: "Phenonix Park Gas Processors Limited (PPGPL)"
    },
    {
        name: "Point Lisas Nitrogen Limited",
        value: "Point Lisas Nitrogen Limited"
    },
    {
        name: "Range Resources Drilling Services Limited",
        value: "Range Resources Drilling Services Limited"
    },
    {
        name: "Repsol E&P T&T Limited",
        value: "Repsol E&P T&T Limited"
    },
    {
        name: "Sadhna Petroleum Ltd.",
        value: "Sadhna Petroleum Ltd."
    },
    {
        name: "Schlumberger Trinidad Inc",
        value: "Schlumberger Trinidad Inc"
    },
    {
        name: "Shell Trinidad & Tobago Limited",
        value: "Shell Trinidad & Tobago Limited"
    },
    {
        name: "Staatsolie Maatschappij",
        value: "Staatsolie Maatschappij"
    },
    {
        name: "TechnipFMC",
        value: "TechnipFMC"
    },
    {
        name: "Touchstone",
        value: "Touchstone"
    },
    {
        name: "Trinidad Inspection Services [TIS]",
        value: "Trinidad Inspection Services [TIS]"
    },
    {
        name: "Trinity Exploration & Production Services Limited",
        value: "Trinity Exploration & Production Services Limited"
    },
    {
        name: "Tullow Oil",
        value: "Tullow Oil"
    },
    {
        name: "Well Services Petroleum Services Limited",
        value: "Well Services Petroleum Services Limited"
    },
    {
        name: "West Indian Energy",
        value: "West Indian Energy"
    },
    {
        name: "Worley Parson",
        value: "Worley Parson"
    },
    {
        name: "YARA Trinidad Limited",
        value: "YARA Trinidad Limited"
    }, 
    {   name: "S.M. Jaleel and Company Limited", 
        value: "S.M. Jaleel and Company Limited" 
    }
];

export const country = [
    {
        name: "Trinidad and Tobago",
        value: "Trinidad and Tobago"
    },
    {
        name: "Guyana",
        value: "Guyana"
    },
    {
        name: "Suriname",
        value: "Suriname"
    },
    {
        name: "Venezuela",
        value: "Venezuela"
    },
    {
        name: "Colombia",
        value: "Colombia"
    },
    {
        name: "Saudi Arabia",
        value: "Saudi Arabia"
    },
    {
        name: "Other",
        value: "Other"
    }
];

export const otherCountries = [
    { name: "Afghanistan", value: "Afghanistan" },
    { name: "Åland Islands", value: "Åland Islands" },
    { name: "Albania", value: "Albania" },
    { name: "Algeria", value: "Algeria" },
    { name: "American Samoa", value: "American Samoa" },
    { name: "Andorra", value: "Andorra" },
    { name: "Angola", value: "Angola" },
    { name: "Anguilla", value: "Anguilla" },
    { name: "Antarctica", value: "Antarctica" },
    { name: "Antigua and Barbuda", value: "Antigua and Barbuda" },
    { name: "Argentina", value: "Argentina" },
    { name: "Armenia", value: "Armenia" },
    { name: "Aruba", value: "Aruba" },
    { name: "Australia", value: "Australia" },
    { name: "Austria", value: "Austria" },
    { name: "Azerbaijan", value: "Azerbaijan" },
    { name: "Bahamas", value: "Bahamas" },
    { name: "Bahrain", value: "Bahrain" },
    { name: "Bangladesh", value: "Bangladesh" },
    { name: "Barbados", value: "Barbados" },
    { name: "Belarus", value: "Belarus" },
    { name: "Belgium", value: "Belgium" },
    { name: "Belize", value: "Belize" },
    { name: "Benin", value: "Benin" },
    { name: "Bermuda", value: "Bermuda" },
    { name: "Bhutan", value: "Bhutan" },
    { name: "Bolivia (Plurinational State of)", value: "Bolivia (Plurinational State of)" },
    { name: "Bonaire, Sint Eustatius and Saba", value: "Bonaire, Sint Eustatius and Saba" },
    { name: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
    { name: "Botswana", value: "Botswana" },
    { name: "Bouvet Island", value: "Bouvet Island" },
    { name: "Brazil", value: "Brazil" },
    { name: "British Indian Ocean Territory", value: "British Indian Ocean Territory" },
    { name: "Brunei Darussalam", value: "Brunei Darussalam" },
    { name: "Bulgaria", value: "Bulgaria" },
    { name: "Burkina Faso", value: "Burkina Faso" },
    { name: "Burundi", value: "Burundi" },
    { name: "Cabo Verde", value: "Cabo Verde" },
    { name: "Cambodia", value: "Cambodia" },
    { name: "Cameroon", value: "Cameroon" },
    { name: "Canada", value: "Canada" },
    { name: "Cayman Islands", value: "Cayman Islands" },
    { name: "Central African Republic", value: "Central African Republic" },
    { name: "Chad", value: "Chad" },
    { name: "Chile", value: "Chile" },
    { name: "China", value: "China" },
    { name: "Christmas Island", value: "Christmas Island" },
    { name: "Cocos (Keeling) Islands", value: "Cocos (Keeling) Islands" },
    { name: "Colombia", value: "Colombia" },
    { name: "Comoros", value: "Comoros" },
    { name: "Congo (the Democratic Republic of the)", value: "Congo (the Democratic Republic of the)" },
    { name: "Congo", value: "Congo" },
    { name: "Cook Islands", value: "Cook Islands" },
    { name: "Costa Rica", value: "Costa Rica" },
    { name: "Croatia", value: "Croatia" },
    { name: "Cuba", value: "Cuba" },
    { name: "Curaçao", value: "Curaçao" },
    { name: "Cyprus", value: "Cyprus" },
    { name: "Czechia", value: "Czechia" },
    { name: "Côte d'Ivoire", value: "Côte d'Ivoire" },
    { name: "Denmark", value: "Denmark" },
    { name: "Djibouti", value: "Djibouti" },
    { name: "Dominica", value: "Dominica" },
    { name: "Dominican Republic", value: "Dominican Republic" },
    { name: "Ecuador", value: "Ecuador" },
    { name: "Egypt", value: "Egypt" },
    { name: "El Salvador", value: "El Salvador" },
    { name: "Equatorial Guinea", value: "Equatorial Guinea" },
    { name: "Eritrea", value: "Eritrea" },
    { name: "Estonia", value: "Estonia" },
    { name: "Eswatini", value: "Eswatini" },
    { name: "Ethiopia", value: "Ethiopia" },
    { name: "Falkland Islands [Malvinas]", value: "Falkland Islands [Malvinas]" },
    { name: "Faroe Islands", value: "Faroe Islands" },
    { name: "Fiji", value: "Fiji" },
    { name: "Finland", value: "Finland" },
    { name: "France", value: "France" },
    { name: "French Guiana", value: "French Guiana" },
    { name: "French Polynesia", value: "French Polynesia" },
    { name: "French Southern Territories", value: "French Southern Territories" },
    { name: "Gabon", value: "Gabon" },
    { name: "Gambia", value: "Gambia" },
    { name: "Georgia", value: "Georgia" },
    { name: "Germany", value: "Germany" },
    { name: "Ghana", value: "Ghana" },
    { name: "Gibraltar", value: "Gibraltar" },
    { name: "Greece", value: "Greece" },
    { name: "Greenland", value: "Greenland" },
    { name: "Grenada", value: "Grenada" },
    { name: "Guadeloupe", value: "Guadeloupe" },
    { name: "Guam", value: "Guam" },
    { name: "Guatemala", value: "Guatemala" },
    { name: "Guernsey", value: "Guernsey" },
    { name: "Guinea", value: "Guinea" },
    { name: "Guinea-Bissau", value: "Guinea-Bissau" },
    { name: "Guyana", value: "Guyana" },
    { name: "Haiti", value: "Haiti" },
    { name: "Heard Island and McDonald Islands", value: "Heard Island and McDonald Islands" },
    { name: "Holy See", value: "Holy See" },
    { name: "Honduras", value: "Honduras" },
    { name: "Hong Kong", value: "Hong Kong" },
    { name: "Hungary", value: "Hungary" },
    { name: "Iceland", value: "Iceland" },
    { name: "India", value: "India" },
    { name: "Indonesia", value: "Indonesia" },
    { name: "Iran (Islamic Republic of)", value: "Iran (Islamic Republic of)" },
    { name: "Iraq", value: "Iraq" },
    { name: "Ireland", value: "Ireland" },
    { name: "Isle of Man", value: "Isle of Man" },
    { name: "Israel", value: "Israel" },
    { name: "Italy", value: "Italy" },
    { name: "Jamaica", value: "Jamaica" },
    { name: "Japan", value: "Japan" },
    { name: "Jersey", value: "Jersey" },
    { name: "Jordan", value: "Jordan" },
    { name: "Kazakhstan", value: "Kazakhstan" },
    { name: "Kenya", value: "Kenya" },
    { name: "Kiribati", value: "Kiribati" },
    { name: "Korea (the Democratic People's Republic of)", value: "Korea (the Democratic People's Republic of)" },
    { name: "Korea (the Republic of)", value: "Korea (the Republic of)" },
    { name: "Kuwait", value: "Kuwait" },
    { name: "Kyrgyzstan", value: "Kyrgyzstan" },
    { name: "Lao People's Democratic Republic", value: "Lao People's Democratic Republic" },
    { name: "Latvia", value: "Latvia" },
    { name: "Lebanon", value: "Lebanon" },
    { name: "Lesotho", value: "Lesotho" },
    { name: "Liberia", value: "Liberia" },
    { name: "Libya", value: "Libya" },
    { name: "Liechtenstein", value: "Liechtenstein" },
    { name: "Lithuania", value: "Lithuania" },
    { name: "Luxembourg", value: "Luxembourg" },
    { name: "Macao", value: "Macao" },
    { name: "Madagascar", value: "Madagascar" },
    { name: "Malawi", value: "Malawi" },
    { name: "Malaysia", value: "Malaysia" },
    { name: "Maldives", value: "Maldives" },
    { name: "Mali", value: "Mali" },
    { name: "Malta", value: "Malta" },
    { name: "Marshall Islands", value: "Marshall Islands" },
    { name: "Martinique", value: "Martinique" },
    { name: "Mauritania", value: "Mauritania" },
    { name: "Mauritius", value: "Mauritius" },
    { name: "Mayotte", value: "Mayotte" },
    { name: "Mexico", value: "Mexico" },
    { name: "Micronesia (Federated States of)", value: "Micronesia (Federated States of)" },
    { name: "Moldova (the Republic of)", value: "Moldova (the Republic of)" },
    { name: "Monaco", value: "Monaco" },
    { name: "Mongolia", value: "Mongolia" },
    { name: "Montenegro", value: "Montenegro" },
    { name: "Montserrat", value: "Montserrat" },
    { name: "Morocco", value: "Morocco" },
    { name: "Mozambique", value: "Mozambique" },
    { name: "Myanmar", value: "Myanmar" },
    { name: "Namibia", value: "Namibia" },
    { name: "Nauru", value: "Nauru" },
    { name: "Nepal", value: "Nepal" },
    { name: "Netherlands", value: "Netherlands" },
    { name: "New Caledonia", value: "New Caledonia" },
    { name: "New Zealand", value: "New Zealand" },
    { name: "Nicaragua", value: "Nicaragua" },
    { name: "Niger", value: "Niger" },
    { name: "Nigeria", value: "Nigeria" },
    { name: "Niue", value: "Niue" },
    { name: "Norfolk Island", value: "Norfolk Island" },
    { name: "Northern Mariana Islands", value: "Northern Mariana Islands" },
    { name: "Norway", value: "Norway" },
    { name: "Oman", value: "Oman" },
    { name: "Pakistan", value: "Pakistan" },
    { name: "Palau", value: "Palau" },
    { name: "Palestine, State of", value: "Palestine, State of" },
    { name: "Panama", value: "Panama" },
    { name: "Papua New Guinea", value: "Papua New Guinea" },
    { name: "Paraguay", value: "Paraguay" },
    { name: "Peru", value: "Peru" },
    { name: "Philippines", value: "Philippines" },
    { name: "Pitcairn", value: "Pitcairn" },
    { name: "Poland", value: "Poland" },
    { name: "Portugal", value: "Portugal" },
    { name: "Puerto Rico", value: "Puerto Rico" },
    { name: "Qatar", value: "Qatar" },
    { name: "Republic of North Macedonia", value: "Republic of North Macedonia" },
    { name: "Romania", value: "Romania" },
    { name: "Russian Federation", value: "Russian Federation" },
    { name: "Rwanda", value: "Rwanda" },
    { name: "Réunion", value: "Réunion" },
    { name: "Saint Barthélemy", value: "Saint Barthélemy" },
    { name: "Saint Helena, Ascension and Tristan da Cunha", value: "Saint Helena, Ascension and Tristan da Cunha" },
    { name: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
    { name: "Saint Lucia", value: "Saint Lucia" },
    { name: "Saint Martin (French part)", value: "Saint Martin (French part)" },
    { name: "Saint Pierre and Miquelon", value: "Saint Pierre and Miquelon" },
    { name: "Saint Vincent and the Grenadines", value: "Saint Vincent and the Grenadines" },
    { name: "Samoa", value: "Samoa" },
    { name: "San Marino", value: "San Marino" },
    { name: "Sao Tome and Principe", value: "Sao Tome and Principe" },
    { name: "Saudi Arabia", value: "Saudi Arabia" },
    { name: "Senegal", value: "Senegal" },
    { name: "Serbia", value: "Serbia" },
    { name: "Seychelles", value: "Seychelles" },
    { name: "Sierra Leone", value: "Sierra Leone" },
    { name: "Singapore", value: "Singapore" },
    { name: "Sint Maarten (Dutch part)", value: "Sint Maarten (Dutch part)" },
    { name: "Slovakia", value: "Slovakia" },
    { name: "Slovenia", value: "Slovenia" },
    { name: "Solomon Islands", value: "Solomon Islands" },
    { name: "Somalia", value: "Somalia" },
    { name: "South Africa", value: "South Africa" },
    { name: "South Georgia and the South Sandwich Islands", value: "South Georgia and the South Sandwich Islands" },
    { name: "South Sudan", value: "South Sudan" },
    { name: "Spain", value: "Spain" },
    { name: "Sri Lanka", value: "Sri Lanka" },
    { name: "Sudan", value: "Sudan" },
    { name: "Suriname", value: "Suriname" },
    { name: "Svalbard and Jan Mayen", value: "Svalbard and Jan Mayen" },
    { name: "Sweden", value: "Sweden" },
    { name: "Switzerland", value: "Switzerland" },
    { name: "Syrian Arab Republic", value: "Syrian Arab Republic" },
    { name: "Taiwan (Province of China)", value: "Taiwan (Province of China)" },
    { name: "Tajikistan", value: "Tajikistan" },
    { name: "Tanzania, United Republic of", value: "Tanzania, United Republic of" },
    { name: "Thailand", value: "Thailand" },
    { name: "Timor-Leste", value: "Timor-Leste" },
    { name: "Togo", value: "Togo" },
    { name: "Tokelau", value: "Tokelau" },
    { name: "Tonga", value: "Tonga" },
    { name: "Trinidad and Tobago", value: "Trinidad and Tobago" },
    { name: "Tunisia", value: "Tunisia" },
    { name: "Turkey", value: "Turkey" },
    { name: "Turkmenistan", value: "Turkmenistan" },
    { name: "Turks and Caicos Islands", value: "Turks and Caicos Islands" },
    { name: "Tuvalu", value: "Tuvalu" },
    { name: "Uganda", value: "Uganda" },
    { name: "Ukraine", value: "Ukraine" },
    { name: "United Arab Emirates", value: "United Arab Emirates" },
    { name: "United Kingdom of Great Britain and Northern Ireland", value: "United Kingdom of Great Britain and Northern Ireland" },
    { name: "United States Minor Outlying Islands", value: "United States Minor Outlying Islands" },
    { name: "United States of America", value: "United States of America" },
    { name: "Uruguay", value: "Uruguay" },
    { name: "Uzbekistan", value: "Uzbekistan" },
    { name: "Vanuatu", value: "Vanuatu" },
    { name: "Venezuela (Bolivarian Republic of)", value: "Venezuela (Bolivarian Republic of)" },
    { name: "Viet Nam", value: "Viet Nam" },
    { name: "Virgin Islands (British)", value: "Virgin Islands (British)" },
    { name: "Virgin Islands (U.S.)", value: "Virgin Islands (U.S.)" },
    { name: "Wallis and Futuna", value: "Wallis and Futuna" },
    { name: "Western Sahara", value: "Western Sahara" },
    { name: "Yemen", value: "Yemen" },
    { name: "Zambia", value: "Zambia" },
    { name: "Zimbabwe", value: "Zimbabwe" }
]

export const conditionDetails = {
    "unsafeact": "Unsafe acts refer to behaviours or actions by persons that increase the risk of accidents or injuries in the workplace",
    "unsafeconditions": "Unsafe conditions refer to physical or environmental factors in the workplace that increase the risk of accidents or injuries"
}

export const observationCategories = [
    {
        name: "Behaviour and Safety Culture",
        value: "behaviour_safety_positive",
        description: "Positive intervention, peer correction (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Behaviour and Safety Culture",
        value: "behaviour_safety_negative",
        description: "Risk-taking behaviour or complacency (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Communication and Signage",
        value: "communication_signage_positive",
        description: "Clear signage and effective communication (Safe Condition)",
        type: "safe_condition"
    },
    {
        name: "Communication and Signage",
        value: "communication_signage_negative",
        description: "Missing, unclear or ignored warnings (Unsafe Condition)",
        type: "unsafe_condition"
    },
    {
        name: "Confined Space",
        value: "confined_space_positive",
        description: "Entry Gas testing, entry permits, standby personnel (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Confined Space",
        value: "confined_space_negative",
        description: "Uncontrolled access, inadequate ventilation or rescue plan (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Emergency Preparedness",
        value: "emergency_prep_negative",
        description: "Blocked exits, missing fire extinguishers, confusion (Unsafe Condition)",
        type: "unsafe_condition"
    },
    {
        name: "Emergency Preparedness",
        value: "emergency_prep_positive",
        description: "Use of emergency equipment, drills, evacuation awareness (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Energy Isolation / Lockout-Tagout (LOTO)",
        value: "loto_positive",
        description: "Verified isolation practices (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Energy Isolation / Lockout-Tagout (LOTO)",
        value: "loto_negative",
        description: "Working on energized systems without isolation (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Environmental Impact",
        value: "environmental_positive",
        description: "Correct waste segregation/disposal, spill prevention (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Environmental Impact",
        value: "environmental_negative",
        description: "Pollution, spills, improper waste handling (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Hazard Identification and Risk Awareness",
        value: "hazard_id_negative",
        description: "Failure to identify or report hazards (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Hazard Identification and Risk Awareness",
        value: "hazard_id_positive",
        description: "Identifying and controlling hazards (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Hazardous Substances / Chemical Handling",
        value: "hazardous_substances_negative",
        description: "Incompatible materials, leaks, poor containment (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Hazardous Substances / Chemical Handling",
        value: "hazardous_substances_positive",
        description: "Safe storage, handling, and labelling (e.g., SDS available) (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Health and Well-being",
        value: "health_wellbeing_negative",
        description: "Fatigue, illness, or substance misuse indicators (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Health and Well-being",
        value: "health_wellbeing_positive",
        description: "Promotion of breaks, hydration, wellness (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Housekeeping and Workplace Organization",
        value: "housekeeping_positive",
        description: "Clean, organized work areas (Safe Condition)",
        type: "safe_condition"
    },
    {
        name: "Housekeeping and Workplace Organization",
        value: "housekeeping_obstructed",
        description: "Obstructed escape routes, combustible debris (Unsafe condition)",
        type: "unsafe_condition"
    },
    {
        name: "Housekeeping and Workplace Organization",
        value: "housekeeping_negative",
        description: "Spills, clutter, poor storage (Unsafe Condition)",
        type: "unsafe_condition"
    },
    {
        name: "Work Environment",
        value: "work_environment_negative",
        description: "Unsafe Physical/Human Factors (Unsafe Condition)",
        type: "unsafe_condition"
    },
    {
        name: "Work Environment",
        value: "work_environment_positive",
        description: "Safe Physical/Human Factors (Safe Condition)",
        type: "safe_condition"
    },
    {
        name: "Cleanliness & Hygiene",
        value: "cleanliness_hygiene_negative",
        description: "Unclean Areas and Unhygienic Practices (Unsafe Condition)",
        type: "unsafe_condition"
    },
    {
        name: "Cleanliness & Hygiene",
        value: "cleanliness_hygiene_positive",
        description: "Clean Areas and Hygienic Practices (Safe Condition)",
        type: "safe_condition"
    },
    {
        name: "Lifting Operations",
        value: "lifting_negative",
        description: "Uncertified lifting gear, no spotters, unsecure loads etc. (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Lifting Operations",
        value: "lifting_positive",
        description: "Use of certified lifting gear, spotters, and lifting plan (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Manual Handling and Ergonomics",
        value: "manual_handling_positive",
        description: "Proper lifting techniques, aids used (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Manual Handling and Ergonomics",
        value: "manual_handling_negative",
        description: "Unsafe posture or overexertion (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Permit to Work (PTW) & Work Authorization",
        value: "ptw_positive",
        description: "Valid permits displayed and followed (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Permit to Work (PTW) & Work Authorization",
        value: "ptw_risk_assessment",
        description: "Valid Pre-job risk assessments conducted (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Permit to Work (PTW) & Work Authorization",
        value: "ptw_negative",
        description: "Working without or deviating from PTW process (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "PPE",
        value: "ppe_positive",
        description: "Correct use/Fit for Purpose (Safe Act)",
        type: "safe_act"
    },
    {
        name: "PPE",
        value: "ppe_negative",
        description: "Incorrect or missing use (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Procedures and Compliance",
        value: "procedures_negative",
        description: "Bypassing procedures or non-compliance (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Procedures and Compliance",
        value: "procedures_positive",
        description: "Following standard procedures (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Quality Deviation / Non-Conformance",
        value: "quality_positive",
        description: "Adherence to quality standards (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Quality Deviation / Non-Conformance",
        value: "quality_negative",
        description: "Defects, rework, or bypassing quality checks (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Tools and Equipment",
        value: "tools_positive",
        description: "Proper use and condition (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Tools and Equipment",
        value: "tools_negative",
        description: "Misuse, damaged, poorly maintained or unsafe tools (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Traffic and Mobile Equipment",
        value: "traffic_positive",
        description: "Safe interaction with vehicles, forklifts, etc. (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Traffic and Mobile Equipment",
        value: "traffic_negative",
        description: "Unsafe pedestrian/vehicle behaviour or conditions (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Training and Competence",
        value: "training_negative",
        description: "Task being performed by unqualified personnel (Unsafe Act)",
        type: "unsafe_act"
    },
    {
        name: "Training and Competence",
        value: "training_positive",
        description: "Verified qualifications, on-the-job training (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Vehicle and Driving Safety",
        value: "vehicle_positive",
        description: "Safe driving behaviour, spotters used in congested areas (Safe Act)",
        type: "safe_act"
    },
    {
        name: "Vehicle and Driving Safety",
        value: "vehicle_negative",
        description: "Unauthorized driving, seatbelt violations, fatigue, Vehicle in visibly poor condition (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Work at Height",
        value: "work_height_negative",
        description: "Lack of fall protection or unsafe access (Unsafe Act/Condition)",
        type: "unsafe_both"
    },
    {
        name: "Work at Height",
        value: "work_height_positive",
        description: "Use of fall protection systems (Safe Act)",
        type: "safe_act"
    }
];



export function getDepartmentName(value) {
    const department = departments.find(dept => dept.value === value);
    return department ? department.name : null;
}

export function getLocationName(value) {
    const location = locations.find(loc => loc.value === value);
    return location ? location.name : null;
}

export function cleanDepartment(department) {
    if (typeof department !== "string") {
      return department;
    }
  
    const parts = department.split(" ");
    const prefixesToRemove = ["TES", "THL"];
  
    if (prefixesToRemove.includes(parts[0])) {
      // remove the first word
      return parts.slice(1).join(" ");
    }
  
    return department; // leave as is
}

export function getSorted(data) {
    return [...data].sort((a, b) =>
      a.name.localeCompare(b.name)
    );
}

export const QhsseUsers = new Set([
    "IRamjit@tuckerenergy.com", 
    "RCaesar@tuckerenergy.com", 
    "Dillon.raymond@tuckerenergy.com",
].map(email => email.toLowerCase()));

export const businessUnitRemappings = [
    {unit: "Wireline Lab", value: "Wireline"},
    {unit: "TTC", value: "Treating Chemicals"}
]

export const enableDaysLimit = false;
export const daysLimit = 60;